module.exports = __webpack_public_path__ + "static/media/yellowbg_member.c30c7e1c.png";